import { supabase } from '../lib/supabase.js';

export class AuthManager {
  constructor() {
    this.isLoading = false;
    // DOM element references
    this.signInBtn = null;
    this.signInText = null;
    this.signInLoading = null;
    this.errorDiv = null;
    this.successDiv = null;
  }

  render() {
    return `
      <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8">
          <div>
            <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Daily Ironing Dashboard
            </h2>
            <p class="mt-2 text-center text-sm text-gray-600">
              Sign in to access the admin dashboard
            </p>
          </div>
          
          <div class="bg-white py-8 px-6 shadow rounded-lg">
            <form id="auth-form" class="space-y-6">
              <div>
                <label for="email" class="block text-sm font-medium text-gray-700">
                  Email address
                </label>
                <input 
                  id="email" 
                  name="email" 
                  type="email" 
                  required 
                  class="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm" 
                  placeholder="Enter your email"
                >
              </div>
              
              <div>
                <label for="password" class="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <input 
                  id="password" 
                  name="password" 
                  type="password" 
                  required 
                  class="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm" 
                  placeholder="Enter your password"
                >
              </div>

              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <input 
                    id="remember-me" 
                    name="remember-me" 
                    type="checkbox" 
                    class="h-4 w-4 text-violet-600 focus:ring-violet-500 border-gray-300 rounded"
                  >
                  <label for="remember-me" class="ml-2 block text-sm text-gray-900">
                    Remember me
                  </label>
                </div>
              </div>

              <div class="space-y-3">
                <button 
                  type="submit" 
                  id="sign-in-btn"
                  class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span id="sign-in-text">Sign in</span>
                  <span id="sign-in-loading" class="hidden">Signing in...</span>
                </button>
              </div>
            </form>
            
            <div id="auth-error" class="hidden mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded"></div>
            <div id="auth-success" class="hidden mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded"></div>
          </div>
        </div>
      </div>
    `;
  }

  bindEvents() {
    const form = document.getElementById('auth-form');
    
    // Store DOM element references
    this.signInBtn = document.getElementById('sign-in-btn');
    this.signInText = document.getElementById('sign-in-text');
    this.signInLoading = document.getElementById('sign-in-loading');
    this.errorDiv = document.getElementById('auth-error');
    this.successDiv = document.getElementById('auth-success');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await this.handleSignIn();
    });
  }

  async handleSignIn() {
    if (this.isLoading) return;

    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;

    this.setLoading(true);
    this.hideMessages();

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      this.showSuccess('Successfully signed in!');
    } catch (error) {
      this.showError(error.message);
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(loading) {
    this.isLoading = loading;

    if (loading) {
      this.signInBtn.disabled = true;
      this.signInText.classList.add('hidden');
      this.signInLoading.classList.remove('hidden');
    } else {
      this.signInBtn.disabled = false;
      this.signInText.classList.remove('hidden');
      this.signInLoading.classList.add('hidden');
    }
  }

  showError(message) {
    this.errorDiv.textContent = message;
    this.errorDiv.classList.remove('hidden');
  }

  showSuccess(message) {
    this.successDiv.textContent = message;
    this.successDiv.classList.remove('hidden');
  }

  hideMessages() {
    this.errorDiv.classList.add('hidden');
    this.successDiv.classList.add('hidden');
  }
}